export function some(promises) {
  let isSomeoneResolved = false;
  let pendingCount = promises.length;
  const rejectReasons = [];

  return new Promise(function (resolve, reject) {
    _.forEach(promises, function (promise) {
      promise
        .then(function (value) {
          if (!isSomeoneResolved) {
            isSomeoneResolved = true;
            resolve(value);
          }
        })
        .catch(function (reason) {
          rejectReasons.push(reason);
        })
        .then(function () {
          pendingCount -= 1;

          if (pendingCount === 0 && !isSomeoneResolved) {
            reject(rejectReasons);
          }
        });
    });
  });
}


export function settle(promises) {
  return Promise.all(
    _.invokeMap(
      promises,
      'then',
      value => ({ value, isFulfilled: true }),
      reason => ({ reason, isRejected: true })
    )
  );
}

export const makeCancelable = promise => {
  let hasCanceled = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      val => (hasCanceled ? reject({ isCanceled: true }) : resolve(val)),
      error => (hasCanceled ? reject({ isCanceled: true }) : reject(error))
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled = true;
    },
  };
};



// WEBPACK FOOTER //
// ./src/shared/utils/promise.js